import { Flex, IconButton, Menu, MenuButton, MenuItem, MenuList, Tooltip } from '@chakra-ui/react';
import { MdCode, MdDataObject, MdEdit, MdMoreVert, MdVisibility } from 'react-icons/md';

import { Order } from '@app/api/models/order';
import { dateTimeBodyRender, TableColumn } from '@app/components/common/table';

import { ExportFormat } from './export-utils';

export const useColumns = ({
  onOpen,
  onExport,
  canChange,
}: {
  onOpen: (order: Order) => void;
  onExport: (order: Order, format: ExportFormat) => void;
  canChange: boolean;
}): TableColumn<Order>[] => {
  return [
    {
      name: 'pid',
      label: '#',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'created_dt',
      label: 'Создан',
      options: {
        filter: {
          type: 'date-range',
          name: 'created',
        },
        sort: true,
        customBodyRender: dateTimeBodyRender(),
      },
    },
    {
      name: 'distributor_name',
      label: 'Дистрибьютор',
      options: {
        filter: { type: 'text', name: 'distributor_id' },
        sort: false,
        customBodyRender: (value: string, { rowData }) => (
          <span>{value || rowData.distributor_id || '—'}</span>
        ),
      },
    },
    {
      name: 'outlet_id',
      label: 'ТТ ID',
      options: {
        filter: { type: 'text', name: 'outlet_id' },
        sort: true,
      },
    },
    {
      name: 'warehouse_name',
      label: 'Склад',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: string) => <span>{value || '—'}</span>,
      },
    },
    {
      name: 'shipping_date',
      label: 'Дата отгрузки',
      options: {
        filter: false,
        sort: true,
        customBodyRender: dateTimeBodyRender(false, true),
      },
    },
    {
      name: 'total_amount',
      label: 'Сумма',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: number) => (
          <span>{value != null ? value.toLocaleString('ru-RU') : '—'}</span>
        ),
      },
    },
    {
      name: 'status_name',
      label: 'Статус',
      options: {
        filter: { type: 'text', name: 'status' },
        sort: false,
        customBodyRender: (value: string, { rowData }) => (
          <span>{value || rowData.status_id || '—'}</span>
        ),
      },
    },
    {
      name: 'user',
      label: 'Пользователь',
      options: {
        filter: { type: 'text', name: 'username' },
        sort: false,
        customBodyRender: (user: Order['user']) => (
          <span>{user?.full_name || user?.username || '—'}</span>
        ),
      },
    },
    {
      name: 'pid',
      label: 'Действия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, { rowData }) => {
          const order = rowData as Order;
          return (
            <Flex gap={2}>
              <Tooltip label={canChange ? 'Редактировать' : 'Просмотр'}>
                <IconButton
                  name="open"
                  aria-label="open"
                  size="sm"
                  onClick={() => onOpen(order)}
                >
                  {canChange ? <MdEdit /> : <MdVisibility />}
                </IconButton>
              </Tooltip>
              <Menu>
                <Tooltip label="Выгрузить">
                  <MenuButton
                    as={IconButton}
                    aria-label="export"
                    size="sm"
                    icon={<MdMoreVert />}
                  />
                </Tooltip>
                <MenuList>
                  <MenuItem
                    icon={<MdDataObject />}
                    onClick={() => onExport(order, 'json')}
                  >
                    JSON
                  </MenuItem>
                  <MenuItem
                    icon={<MdCode />}
                    onClick={() => onExport(order, 'xml')}
                  >
                    XML
                  </MenuItem>
                </MenuList>
              </Menu>
            </Flex>
          );
        },
      },
    },
  ];
};
